import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Card} from "antd";
import { ShoppingCartOutlined, } from "@ant-design/icons";

import { fetchProductsByBrand } from "../../Redux/slice/productSlice";
import { useNavigate } from "react-router-dom";

import { Helmet } from "react-helmet";

const formatPrice = (price) => price.toLocaleString();
const BRAND_ID = "760af684-7a19-46ab-acc5-7445ef32073a";
const backendBaseURL = "https://smfteapi.salesmate.app";

const Samsung = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { brandProducts, loading } = useSelector((state) => state.products);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  

  useEffect(() => {
    dispatch(fetchProductsByBrand(BRAND_ID));
  }, [dispatch]);


  
  const filteredProducts = brandProducts.filter((item) => item.productID );

  return (
    
    <div className="container mx-auto p-4 min-h-screen flex flex-col">


<Helmet>
  <title>Buy Samsung Mobile Phones | Best Deals on samsung phones</title>
  <meta name="description" content="Get the latest Samsung Mobile Phones with 12GB RAM, 512GB storage, and fast delivery!" />
  <meta name="keywords" content="Samsung Mobile Phones, Buy Samsung Phones, 4K AMOLED Display, Best Phone Deals, Smart Devices" />
  <meta name="author" content="Samsung" />
  <link rel="canonical" href="https://www.frankotrading.com/product/samsung" />
  {/* Open Graph Meta Tags */}
  <meta property="og:title" content="Buy Samsung Mobile Phones | Best Deals on Phones & Accessories" />
  <meta property="og:description" content="Get the latest Samsung Mobile Phones with 12GB RAM, 512GB storage, and fast delivery!" />
  <meta property="og:image" content={filteredProducts[0].productImage ? `${backendBaseURL}/Media/Products_Images/${filteredProducts[0].productImage.split("\\").pop()}` : "default-image-url"} />
  <meta property="og:url" content="https://www.frankotrading.com/product/samsung" />
  <meta property="og:type" content="product" />

  {/* Twitter Meta Tags */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Buy Samsung Mobile Phones | Best Deals on Phones & Accessories" />
  <meta name="twitter:description" content="Get the latest Samsung Mobile Phones." />
  <meta name="twitter:image" content={filteredProducts[0].productImage ? `${backendBaseURL}/Media/Products_Images/${filteredProducts[0].productImage.split("\\").pop()}` : "default-image-url"} />

  {/* JSON-LD Structured Data */}
  <script type="application/ld+json">
  {JSON.stringify({
    "@context": "https://schema.org",
    "@type": "Product",
    "name": filteredProducts[0].productName || "Samsung Mobile Phone",
    "sku": filteredProducts[0].productID || "N/A",
    "image": filteredProducts[0].productImage 
      ? `${backendBaseURL}/Media/Products_Images/${filteredProducts[0].productImage.split("\\").pop()}`
      : "https://www.frankotrading.com/default-product-image.jpg",
    "description": filteredProducts[0].description || "Latest Samsung mobile phone available now.",
    "brand": {
      "@type": "Brand",
      "name": filteredProducts[0].brandName || "Samsung"
    },
    "category": filteredProducts[0].category || "Electronics",
    "offers": {
      "@type": "Offer",
      "priceCurrency": "GHS",
      "price": filteredProducts[0].price,
      "priceValidUntil": "2025-12-31",
      "itemCondition": "https://schema.org/NewCondition",
     "availability": "https://schema.org/InStock",
      "url": `https://www.frankotrading.com/product/${filteredProducts[0].productID}`,
      "seller": {
        "@type": "Organization",
        "name": "Franko Trading"
      },
      "shippingDetails": {
        "@type": "OfferShippingDetails",
        "shippingRate": {
          "@type": "MonetaryAmount",
          "currency": "GHS",
          "value": "30.00"
        },
        "shippingDestination": {
          "@type": "DefinedRegion",
          "addressCountry": "GH"
        },
        "deliveryTime": {
          "@type": "ShippingDeliveryTime",
          "handlingTime": {
            "@type": "QuantitativeValue",
            "minValue": 1,
            "maxValue": 2,
            "unitCode": "DAY"
          },
          "transitTime": {
            "@type": "QuantitativeValue",
            "minValue": 3,
            "maxValue": 5,
            "unitCode": "DAY"
          }
        }
      },
      "hasMerchantReturnPolicy": {
        "@type": "MerchantReturnPolicy",
        "returnPolicyCategory": "https://schema.org/MerchantReturnFiniteReturnWindow",
        "merchantReturnDays": 14,
        "returnMethod": "https://schema.org/ReturnByMail",
        "returnFees": "https://schema.org/FreeReturn", 
        "applicableCountry": "GH"
      },
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.5",
      "reviewCount": "120"
    },
    "review": {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "John Doe"
      },
      "reviewRating": {
        "@type": "Rating",
        "ratingValue": "5",
        "bestRating": "5"
      }
    }
  })}
</script>

</Helmet>

   
         

      {/* For You Section */}
      <div className="w-full  py-4 px-4 mt-2">
      <div className="flex flex-col items-center text-center my-6">
  <span className="text-sm font-semibold text-red-500 tracking-wide">OFFICIAL</span>
  <div className="relative w-full flex items-center justify-center">
    <hr className="w-1/4 border-gray-300 hidden md:block" />
    <h2 className="text-xl md:text-2xl font-bold text-gray-800 mx-4">
   SAMSUNG STORE
    </h2>
    <hr className="w-1/4 border-gray-300 hidden md:block" />
  </div>
</div>

        {loading ? (
           <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
           {Array.from({ length: 12 }).map((_, index) => (
             <div
               key={index}
               className="animate-pulse border rounded-lg shadow p-3 bg-gray-100 relative"
             >
               <div
                 className="absolute inset-0 bg-center bg-no-repeat opacity-10"
                 style={{
                   backgroundImage: "url('/frankoIcon.png')",
                   backgroundSize: '90px',
                   backgroundPosition: 'center center',
                 }}
               ></div>
               <div className="h-36 bg-gray-200 rounded-lg"></div>
               <div className="h-3 bg-gray-200 rounded w-3/4 mt-2"></div>
               <div className="h-3 bg-gray-200 rounded w-1/2 mt-1"></div>
             </div>
           ))}
         </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-2">
            {filteredProducts.map((item) => (
              <Card
                key={item.productID}
                hoverable
                className="rounded-lg shadow-lg transition-transform transform hover:scale-105 hover:shadow-lg group"
                cover={
                  <div
                    onClick={() =>
                      navigate(`/product/${item.productID}`)
                    }
                    className="cursor-pointer relative"
                  >
                    <img
                      src={`${backendBaseURL}/Media/Products_Images/${item.productImage.split("\\").pop()}`}
                      alt={item.productName}
                      className="w-full object-cover rounded-lg"
                    />
                  </div>
                }
              >
                <Card.Meta
                  title={<p className="font-semibold text-sm truncate">{item.productName}</p>}
                  description={<p className="text-red-500 font-bold text-sm">₵{formatPrice(item.price)}.00</p>}
                />
                <Button
                  shape="circle"
                  icon={<ShoppingCartOutlined />}
                  className="absolute bottom-2 right-2 bg-red-500 text-white opacity-0 group-hover:opacity-100 transition-opacity"
                  onClick={(e) => {
                    e.stopPropagation();
                 
                  }}
                />
              </Card>
            ))}
          </div>
        )}
      </div>

      {/* Modal for Enlarged Image */}
      
    </div>
  );
};

export default Samsung;
